import { ResolverTag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';
import { select } from '@swf/core/store';
import type { Dispatch } from '@swf/core/store';
import { Prompt } from '@swf/first';

import {
  TXTWCL_Exit_the_tour,
  TXTWCL_ThatXs_all_you_need_to_know_to_ELL,
  TXTWCL_YOUXRE_ALL_SET
} from './CashierTourFinished.messages.json';
import styles from './CashierTourFinished.scss';

const CashierTourFinished: React.FC = () => {
  const { localSettings } = useDispatch<Dispatch>();
  const { cashierTour } = useSelector(select.localSettings.get);

  return (
    <>
      {cashierTour?.lastModalShown && cashierTour.onboardingFinished && (
        <Prompt
          title={{
            translation: TXTWCL_YOUXRE_ALL_SET
          }}
          variant="celebration"
          primaryButton={{ translation: TXTWCL_Exit_the_tour }}
          onPrimaryButtonClick={() => {
            localSettings.set({ cashierTour: { onboardingFinished: true } });
          }}
          noCloseButton
        >
          <Translation
            {...TXTWCL_ThatXs_all_you_need_to_know_to_ELL}
            values={{
              a: (msg: string) => (
                <ResolverLink
                  className={styles.finalStepResolver}
                  resolverTag={ResolverTag.HelpCenter}
                >
                  {msg}
                </ResolverLink>
              )
            }}
          />
        </Prompt>
      )}
    </>
  );
};

export default CashierTourFinished;
